import { useUISkin } from "@/data/UISkinContext";
import { Navigate } from "react-router-dom";
import ProjectsHub from "./ProjectsHub";

export default function ProjectsHubRoute() {
  const { skin } = useUISkin();
  if (skin !== "cockpit") return <Navigate to="/jobs" replace />;
  return <ProjectsHub />;
}
